// Server-signed CIMA HPM gateway attempts, keyed by the payment method ID that HPM created.
// The browser only carries these back to the backend; it never reads or chooses the gateway.
const attempts = new Map<string, string>();

export const recordCimaGatewayAttempt = (paymentMethodId?: string, gatewayAttempt?: string): void => {
  if (paymentMethodId && gatewayAttempt) attempts.set(paymentMethodId, gatewayAttempt);
};

export const getCimaGatewayAttempt = (paymentMethodId?: string | null): string | undefined =>
  paymentMethodId ? attempts.get(paymentMethodId) : undefined;

export const clearCimaGatewayAttempts = (): void => attempts.clear();
